export const GET_USER_DATA_START = 'GET_USER_DATA_START';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILURE = 'GET_USER_DATA_FAILURE';
export const GET_USER_DATA_END = 'GET_USER_DATA_END';
export const USER_ONBOARDED = 'USER_ONBOARDED';
